export default "__VITE_ASSET__Blvy_PZ___"